import { Stack } from '@mui/material';

import { DeviceStatusSection } from '@/components/spotter/statusTab/DeviceStatusSection';

export const StatusTabContent = () => {
    return (
        <Stack gap={4}>
            <DeviceStatusSection />
        </Stack>
    );
};
